export const CREATE_STUDENT_SUBJECT_REQUIST = "CREATE_STUDENT_SUBJECT_REQUIST";
export const CREATE_STUDENT_SUBJECT_SUCCESS = "CREATE_STUDENT_SUBJECT_SUCCESS";
export const CREATE_STUDENT_SUBJECT_FAIELD = "CREATE_STUDENT_SUBJECT_FAIELD";

export const SHOW_STUDENT_SUBJECT_REQUIST = "SHOW_STUDENT_SUBJECT_REQUIST";
export const SHOW_STUDENT_SUBJECT_SUCCESS = "SHOW_STUDENT_SUBJECT_SUCCESS";
export const SHOW_STUDENT_SUBJECT_FAIELD = "SHOW_STUDENT_SUBJECT_FAIELD";


